import {useLocation} from 'react-router';

const useAppSection = () => {
  const location = useLocation();

  const [basePage, detailPage] = location.pathname.slice(1).split('/');

  const appSection = [
    basePage.charAt(0).toUpperCase() + basePage.slice(1),
    detailPage ? 'Detail' : null,
  ]
    .filter(p => !!p)
    .join(' ');

  return {appSection, detailPage};
};

export default useAppSection;
